var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenuser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 50,
    height: 50,
    rx: 5,
    fill: "#EEFDF4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_229_122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5 25.4286C27.0155 25.4286 28.469 24.8265 29.5406 23.7549C30.6122 22.6833 31.2143 21.2298 31.2143 19.7143C31.2143 18.1988 30.6122 16.7453 29.5406 15.6737C28.469 14.602 27.0155 14 25.5 14C23.9845 14 22.531 14.602 21.4594 15.6737C20.3878 16.7453 19.7857 18.1988 19.7857 19.7143C19.7857 21.2298 20.3878 22.6833 21.4594 23.7549C22.531 24.8265 23.9845 25.4286 25.5 25.4286ZM21.2143 27.8929C17.9107 28.8616 15.5 31.9152 15.5 35.5312C15.5 36.2634 16.0938 36.8571 16.8259 36.8571H34.1741C34.9062 36.8571 35.5 36.2634 35.5 35.5312C35.5 31.9152 33.0893 28.8616 29.7857 27.8929V30.1607C31.0179 30.4777 31.9286 31.5982 31.9286 32.9286V34.7143C31.9286 35.1071 31.6071 35.4286 31.2143 35.4286H30.5C30.1071 35.4286 29.7857 35.1071 29.7857 34.7143C29.7857 34.3214 30.1071 34 30.5 34V32.9286C30.5 32.1384 29.8616 31.5 29.0714 31.5C28.2812 31.5 27.6429 32.1384 27.6429 32.9286V34C28.0357 34 28.3571 34.3214 28.3571 34.7143C28.3571 35.1071 28.0357 35.4286 27.6429 35.4286H26.9286C26.5357 35.4286 26.2143 35.1071 26.2143 34.7143V32.9286C26.2143 31.5982 27.125 30.4777 28.3571 30.1607V27.6116C28.0893 27.5848 27.817 27.5714 27.5402 27.5714H23.4598C23.183 27.5714 22.9107 27.5848 22.6429 27.6116V30.5312C23.6741 30.8393 24.4286 31.7946 24.4286 32.9286C24.4286 34.308 23.308 35.4286 21.9286 35.4286C20.5491 35.4286 19.4286 34.308 19.4286 32.9286C19.4286 31.7946 20.183 30.8393 21.2143 30.5312V27.8929ZM21.9286 34C22.2127 34 22.4853 33.8871 22.6862 33.6862C22.8871 33.4853 23 33.2127 23 32.9286C23 32.6444 22.8871 32.3719 22.6862 32.171C22.4853 31.97 22.2127 31.8571 21.9286 31.8571C21.6444 31.8571 21.3719 31.97 21.171 32.171C20.97 32.3719 20.8571 32.6444 20.8571 32.9286C20.8571 33.2127 20.97 33.4853 21.171 33.6862C21.3719 33.8871 21.6444 34 21.9286 34Z",
    fill: "#4AF06F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_229_122"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 22.8571,
    fill: "white",
    transform: "translate(15.5 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenuser);
export default __webpack_public_path__ + "static/media/greenuser.004e117636fc7d55a44c6b1d72754d22.svg";
export { ForwardRef as ReactComponent };